<template>
  <div id="app">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
   
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
export default {
  name: "App",
  data() {
    return {
    };
  },
  watch: {
    //使用watch 监听$router的变化
    $route(to, from) {
      // //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      // if (to.meta.index > from.meta.index) {
      //   //设置动画名称
      //   this.transitionName = "slide-left";
      // } else {
      //   this.transitionName = "slide-right";
      // }
      // Toast.loading({
      //   message: "页面加载中...",
      //   forbidClick: true,
      //   loadingType: "spinner",
      // });
    },
  },
};
</script>
<style>
html {
  overflow-y: scroll !important;
  overflow-x: hidden;
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 300ms;
  position: absolute;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
</style>





// WEBPACK FOOTER //
// src/App.vue